export const ledgerKeys = {
  all: ['ledgers'] as const,
  list: () => ['ledgers', 'list'] as const,
  detail: (ledgerId: string) => ['ledgers', 'detail', ledgerId] as const,
  scoped: (ledgerId: string) => ['ledger', ledgerId] as const,
};
